import 'bootstrap/dist/css/bootstrap.min.css'
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Footer from "./pages/components/Footer/Footer";
import Header from "./pages/components/Header/Header";
import ConfigContext from './context/configContext';
import IConfiguration from "./context/IConfiguration";

import ReviewYourPhoneNumberPage from "./pages/ReviewYourPhoneNumber/ReviewYourPhoneNumberPage";
import TransferYourPhonePage from "./pages/TransferYourPhone/TransferYourPhone";
import TransferSubmittedPage from "./pages/TransferSubmitted/TransferSubmitted";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-MX5HTF2",
};
TagManager.initialize(tagManagerArgs);

function App({config}: { config: IConfiguration }) {

  // Debugging Loaded Deployment Configuration File
  // console.log('LOG: Configuration Deployment settings:');
  // console.log(`\tACCT_MGT_DEPLOY_ENV=${config.ACCT_MGT_DEPLOY_ENV}`);
  // console.log(`\tACCT_MGT_PORTING_FRONTEND=${config.ACCT_MGT_PORTING_FRONTEND}`);
  // console.log(`\tACCT_MGT_PORTING_BACKEND=${config.ACCT_MGT_PORTING_BACKEND}`);

  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <TransferYourPhonePage />,
      },
      {
        path: "/review-phone-number",
        element: <ReviewYourPhoneNumberPage />,
      },
      {
        path: "/transfer-submitted",
        element: <TransferSubmittedPage />,
      },
      {
        path: "redirection",
        element: <div>Redirection should happen here</div>,
      },
    ],
    {
      basename: "/porting",
    }
  );

  return (
    <div className="App">
      <ConfigContext.Provider value={config}>
        <Header />
        <RouterProvider router={router} />
        <Footer />
      </ConfigContext.Provider>
    </div>
  );
}

export default App;
